import * as React from 'react';
import { SVGProps } from 'react';

export const Lamp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.75 11.0887V9.63873C19.7701 8.72515 19.468 7.83363 18.8966 7.12052C18.3252 6.40741 17.521 5.91821 16.625 5.73873C16.0871 5.64782 15.536 5.67533 15.0099 5.81935C14.4838 5.96336 13.9954 6.2204 13.5789 6.57256C13.1624 6.92471 12.8277 7.36349 12.5981 7.8583C12.3686 8.35311 12.2498 8.89203 12.25 9.43748V11.0887C10.4743 11.7821 8.9255 12.9537 7.77527 14.4738C6.62504 15.9938 5.91839 17.8028 5.73372 19.7C5.72579 19.8278 5.74435 19.9559 5.78823 20.0762C5.83212 20.1966 5.90038 20.3065 5.98875 20.3992C6.07712 20.4919 6.18368 20.5654 6.30176 20.615C6.41985 20.6646 6.5469 20.6893 6.67497 20.6875H25.325C25.453 20.6893 25.5801 20.6646 25.6982 20.615C25.8163 20.5654 25.9228 20.4919 26.0112 20.3992C26.0996 20.3065 26.1678 20.1966 26.2117 20.0762C26.2556 19.9559 26.2742 19.8278 26.2662 19.7C26.0815 17.8028 25.3749 15.9938 24.2247 14.4738C23.0744 12.9537 21.5256 11.7821 19.75 11.0887Z"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 1.9375V5.6875"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.75 20.6875C19.75 21.6821 19.3549 22.6359 18.6517 23.3392C17.9484 24.0424 16.9946 24.4375 16 24.4375C15.0054 24.4375 14.0516 24.0424 13.3483 23.3392C12.6451 22.6359 12.25 21.6821 12.25 20.6875"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 30.0625V28.1875"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.5625 26.3125L24.4375 29.125"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.4375 26.3125L7.5625 29.125"
      stroke="#071114"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Lamp;
